import { render, staticRenderFns } from "./DataPermModuleSelect.vue?vue&type=template&id=0eea149e&scoped=true"
import script from "./DataPermModuleSelect.vue?vue&type=script&lang=js"
export * from "./DataPermModuleSelect.vue?vue&type=script&lang=js"
import style0 from "./DataPermModuleSelect.vue?vue&type=style&index=0&id=0eea149e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eea149e",
  null
  
)

export default component.exports